import { NotificationDiv } from "../SidebarNotificationsStyles";
import { IThirdPartyBillingAuthorization } from "./model";

const ThirdPartyBillingAuthorizationNotificationCard = (props: {
  notification: IThirdPartyBillingAuthorization;
}) => {
  const { notification } = props;
  const { volante } = notification;

  return (
    <div>
      <NotificationDiv
        fontWeight={500}
        fontSize="1.1rem"
        marginTop="0.5rem"
        color="#2E353D"
        paddingLeft="1rem"
      >
        Nº DAM: <b>{volante.dam_num}</b>
      </NotificationDiv>
      <div style={{ display: "flex" }}>
        <NotificationDiv
          fontWeight={500}
          fontSize="1.1rem"
          marginTop="0.5rem"
          color="#2E353D"
          paddingBottom="1rem"
          paddingLeft="1rem"
        >
          Nº VOLANTE: <b>{volante.volante_detail.volante_num}</b>
        </NotificationDiv>
      </div>
    </div>
  );
};

export default ThirdPartyBillingAuthorizationNotificationCard;
